module.exports = __webpack_public_path__ + "static/img/news2.dd98b29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/news2.jpg
// module id = tQ3K
// module chunks = 0